import ModalController from './modal-controller';

export default class Modal {
    constructor(options) {
        this._content = null;
        this.options = Object.assign({}, Modal.defaultOptions, options);

        this.controller = ModalController.getInstance();
    }

    open(refresh = true) {
        this.controller.open(this, refresh);
    }

    getPreparedContent(refresh) {
        if (this._content === null || refresh) {
            return this.getContent().then((content) => {
                this._content = content;
                return this._content;
            });
        }
        return Promise.resolve(this._content);
    }

    close() {
        this.controller.close();
    }

    getContent() {
        throw new Error('You have to implement the method getContent!');
    }

    disableClosing() {
        this.options.closable = false;
    }

    enableClosing() {
        this.options.closable = true;
    }
}

Modal.defaultOptions = {
    closable: true
};



// WEBPACK FOOTER //
// ./app/components/modal/js/modal.js